function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 2511;


//////////////////
// WEBPACK FOOTER
// ./src/extension ^\.\/.*\/view\/epic$
// module id = 2511
// module chunks = 0